import React from "react";
import { Chart } from "react-charts";
import { useSelector } from "react-redux";
import { CommonState } from "../store/types/common";

const BarChart: React.FC<{ label?: string }> = ({ label }): JSX.Element => {
  const common = useSelector((state: { common: CommonState }) => state.common);
  const { barChartData } = common;
  const [activeSeriesIndex, setActiveSeriesIndex] = React.useState(-1);
  const [maxValue, setMaxValue] = React.useState(100);
  const [data, setData] = React.useState([]);
  const axes = React.useMemo(
    () => [
      {
        primary: true,
        type: "ordinal",
        position: "bottom",
        show: true,
      },
      {
        type: "linear",
        position: "left",
        show: true,
      },
    ],
    []
  );
  const secondaryAxes = React.useMemo(
    (): any[] => [
      {
        getValue: (datum: any) => datum.secondary,
        elementType: "bar",
        scaleType: "linear",
        min: 0,
        max: maxValue
      },
    ],
    [data]
  );

  const primaryAxis = React.useMemo(
    (): any => ({
      getValue: (datum: any) => datum.primary,
      elementType: "bar",
      scaleType: "band"
    }),
    []
  );
  const series = React.useMemo(
    () => ({
      showPoints: false,
      type: "bar",
    }),
    []
  );

  React.useEffect(() => {
    if (barChartData && barChartData.length > 0) {
      let max  = Math.max(...barChartData.map((element:any) => {
        return Math.max(...element.data.map((o:any) => o.secondary))
      }));
      setMaxValue(max);
      setData(barChartData);
    }
  }, [barChartData])
  

  const cursor = React.useMemo(
    () => ({
      render: (props: any) => <span>{(props.formattedValue || "").toString()}</span>,
    }),
    []
  );

  const getSeriesStyle = React.useCallback(
    (series) => ({
      color: `#${series.index % 2 === 0 ? "5641B8" : "66CACC"}`,
      width: "34px",
      rx: "5px",
      ry: "5px",
      tranform: "translate(39px, 0)",
    }),
    []
  );

  const onFocus = React.useCallback(
    (focused) => setActiveSeriesIndex(focused ? focused.series.id : -1),
    [setActiveSeriesIndex]
  );

  return (
    <div className="h-75 w-50 m-auto">
      {label && <div className="text-sm font-weight-bold ml-2">{label}</div>}
      <Chart
      options={{
        axes,
        data,
        secondaryAxes,
        primaryAxis,
        series,
        cursor,
        getSeriesStyle,
        onFocus
      }}
      />
    </div>
  );
};

export default BarChart;
